<script lang="ts" setup>
import { computed, toRefs } from "vue";
import Icon from "../Icon/Icon.vue";

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    errors?: Array<string>;
    disabled?: boolean;
  }>(),
  { errors: () => [], disabled: false },
);

const { errors } = toRefs(props);

defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const hasErrors = computed(() => {
  return errors.value && errors.value.length > 0;
});
</script>

<template>
  <label
    class="checkbox-field"
    :data-checked="modelValue"
    :data-disabled="disabled"
  >
    <div class="checkbox-field--wrapper">
      <div class="checkbox-field--input-wrapper">
        <input
          class="checkbox-field--input"
          type="checkbox"
          :value="modelValue"
          :checked="modelValue"
          :disabled="disabled"
          @input="
            $emit(
              'update:modelValue',
              ($event.target as HTMLInputElement).checked,
            )
          "
        />
        <Icon
          icon="check"
          class="checkbox-field--input-icon"
        />
      </div>
      <span class="checkbox-field--label">
        <slot></slot>
      </span>
    </div>
    <span
      v-if="hasErrors"
      class="checkbox-field--error-message"
      >{{ errors[0] }}</span
    >
  </label>
</template>

<style scoped>
@import "CheckboxField.css";
</style>
